import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
  UPDATE_MANY,
  DELETE,
  DELETE_MANY
} from "react-admin";

const APP_NAME = process.env.APP_NAME;

/**
 * Maps react-admin queries to a REST API implemented using Java Spring Boot and Swagger
 *
 * @example
 * GET_LIST     => GET http://my.api.url/posts?page=0&pageSize=10
 * GET_ONE      => GET http://my.api.url/posts/123
 * GET_MANY     => GET http://my.api.url/posts?id=1234&id=5678
 * UPDATE       => PUT http://my.api.url/posts/123
 * CREATE       => POST http://my.api.url/posts
 * DELETE       => DELETE http://my.api.url/posts/123
 */
export default () => {
  const apiUrl = process.env.BE_API_URL;

  /**
   * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
   * @param {String} resource Name of the resource to fetch, e.g. 'posts'
   * @param {Object} params The data request params, depending on the type
   * @returns {Object} { url, options } The HTTP request parameters
   */
  const convertDataRequestToHTTP = (type, resource, params) => {
    let url = "";
    const options = {};
    const token = localStorage.getItem(APP_NAME + "token");

    options.headers = new Headers({
      Accept: "application/json",
      token: token
    });

    switch (type) {
      case GET_LIST: {
        /*
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        let filter = "";
        if (Object.keys(params.filter).length !== 0) {
          filter = "&filter=";
          for (const key in params.filter) {
            if (params.filter.hasOwnProperty(key)) {
              const value = params.filter[key];
              filter = filter.concat(`${key}:${value}`);
            }
          }
        }
        url = `${apiUrl}/${resource}?page=${page -
          1}&pageSize=${perPage}&sort=${field}:${order}${filter}`;*/
        url = `${apiUrl}/${resource}`;
        break;
      }
      case GET_ONE:
        url = `${apiUrl}/${resource}${params && params.id
          ? "/" + params.id
          : ""}`;
        break;
      case GET_MANY: {
        // const query = {
        //   filter: JSON.stringify({ id: params.ids })
        // };
        // let idStr = "ids=";
        // const queryString = params.ids.map(id => `${id}`);

        url = `${apiUrl}/${resource}`;
        break;
      }
      case GET_MANY_REFERENCE: {
        const { page, perPage } = params.pagination;
        url = `${apiUrl}/${resource}?page=${page - 1}&pageSize=${perPage}`;
        break;
      }
      case UPDATE:
        url = `${apiUrl}/${resource}/${params.id}`;
        // options.headers.append("Content-Type", "application/json");
        // options.headers.append(
        //   "token",
        //   localStorage.getItem(APP_NAME + "token")
        // );
        options.method = "PUT";
        options.body = JSON.stringify(params.data);
        break;
      case CREATE:
        url = `${apiUrl}/${resource}`;
        options.headers.append("Content-Type", "application/json");
        options.method = "POST";
        options.body = JSON.stringify(params.data);
        break;
      case DELETE:
        url = `${apiUrl}/${resource}/${params.id}`;
        options.method = "DELETE";
        break;
      default:
        throw new Error(`Unsupported fetch action type ${type}`);
    }
    return { url, options };
  };

  /**
   * @param {Object} response HTTP response from fetch()
   * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
   * @param {String} resource Name of the resource to fetch, e.g. 'posts'
   * @param {Object} params The data request params, depending on the type
   * @returns {Object} Data response
   */
  const convertHTTPResponse = (items, type, resource, params) => {
    //TODO ver los otros casos como nombramos a items
    switch (type) {
      case GET_MANY:
      case GET_LIST:
      case GET_MANY_REFERENCE:
        const { errorMessage } = items;
        if (errorMessage) {
          return {
            data: [],
            total: 0
          };
        }
        if (items && items[0] && !items[0].id) {
          const resourceName =
            resource.indexOf("/") !== -1
              ? resource.substring(0, resource.indexOf("/") - 1)
              : resource;
          items.forEach(item => {
            item.id = item[resourceName + "Id"];
          });
        }
        return {
          data: items,
          total: parseInt(items.length, 10)
        };
      case CREATE:
        return { data: { ...params.data, id: items.orderNumber } };
      case GET_ONE:
        if (items && !items.id) {
          const id =
            resource.indexOf("/") !== -1
              ? resource.substring(
                  resource.lastIndexOf("/") + 1,
                  resource.length
                )
              : resource;
          items.id = id;
        }
        return { data: items };
      default:
        return { data: items };
    }
  };

  /**
   * @param {string} type Request type, e.g GET_LIST
   * @param {string} resource Resource name, e.g. "posts"
   * @param {Object} payload Request parameters. Depends on the request type
   * @returns {Promise} the Promise for a data response
   */
  return (type, resource, params) => {
    if (!localStorage.getItem(APP_NAME + "token")) {
      localStorage.removeItem(APP_NAME + "token");
      localStorage.setItem("not_authenticated", true);
      throw new Error();
    }

    const token = localStorage.getItem(APP_NAME + "token");
    if (type === UPDATE_MANY) {
      return Promise.all(
        params.ids.map(id => {
          const options = {};
          options.headers = new Headers({
            Accept: "application/json",
            token: token
          });
          options.method = "PUT";
          options.body = JSON.stringify(params.data);
          return fetch(`${apiUrl}/${resource}/${id}`, options);
        })
      ).then(responses => ({
        data: responses.map(response => response.json)
      }));
    }
    // simple-rest doesn't handle filters on DELETE route, so we fallback to calling DELETE n times instead
    if (type === DELETE_MANY) {
      return Promise.all(
        params.ids.map(id => {
          const options = {};
          options.headers = new Headers({
            Accept: "application/json",
            token: token
          });
          options.method = "DELETE";
          return fetch(`${apiUrl}/${resource}/${id}`, options);
        })
      ).then(responses => ({
        data: responses.map(response => response.json)
      }));
    }

    if (type === GET_MANY) {
      return Promise.all(
        params.ids.map(id => {
          const options = {};
          options.headers = new Headers({
            Accept: "application/json",
            token: token
          });
          options.method = "GET";
          return fetch(`${apiUrl}/${resource}/${id}`, options).then(resp => {
            return validateResponseStatus(resp).then(json => {
              json.id = resp.url.split("/").slice(-1)[0];
              return json;
            });
          });
        })
      ).then(responses => {
        return convertHTTPResponse(responses, type, resource, params);
      });
    }

    const { url, options } = convertDataRequestToHTTP(type, resource, params);

    return fetch(url, options)
      .then(response => {
        return validateResponseStatus(response);
      })
      .then(response => {
        if (response.errorNumber && response.errorNumber === 1002) {
          localStorage.removeItem(APP_NAME + "token");
          localStorage.removeItem("access");
          localStorage.setItem("not_authenticated", true);
          throw new Error();
        } else {
          return convertHTTPResponse(response, type, resource, params);
        }
      });
  };
};

/**
 * validate errors in the response
 * @param {*} response
 */
const validateResponseStatus = response => {
  if (response.status < 200 || response.status >= 300) {
    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem(APP_NAME + "token");
      localStorage.removeItem("access");
      localStorage.setItem("not_authenticated", true);
      throw new Error();
    }
    throw new Error();
  }
  return response.json();
};
